import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { Placement, PlacementSearchParam } from '../models';
import { map } from 'rxjs/operators';

interface IPlacementSearchParameters {
  mode: string;
  placement_ids: number[];
}

@Injectable({ providedIn: 'root' })
export class PlacementService {

  private path = '/placements';

  constructor(private http: AlloxApiService) { }

  public search(param: PlacementSearchParam) {
    return this.http.get<[]>(this.path + param.toFlattenURLQuery()).pipe(
      map(objs => objs.map(obj => new Placement(obj)))
    );
  }

  public searchByIDs(params: IPlacementSearchParameters) {
    return this.http.post<Placement[]>(this.path + '/search', params).pipe(
      map(objs => objs.map(obj => new Placement(obj)))
    );
  }

  public fetch(id: number, param: PlacementSearchParam) {
    return this.http.get(this.path + '/' + id + param.toURLQuery()).pipe(
      map(obj => new Placement(obj))
    );
  }

}
